import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiConfig from '../axiosConfig';

export const getFlashSaleById = createAsyncThunk(
	'flashSale/get/id',
	async ({ flashSaleId }) => {

		const response = await apiConfig
			.get(`flash-sale/${flashSaleId}`)
			.then((response) => response)
			.catch((error) => error);

		return response.data;
	}
);

export const getProducts = createAsyncThunk(
	'flashSale/product/get',
	async ({ flashSaleId, active = true}) => {

		const response = await apiConfig
			.get(`flash-sale-products/list/${flashSaleId}/${active ? '1' : '0'}`)
			.then((response) => response)
			.catch((error) => error);

		return response.data;
	}
);

export const addProduct = createAsyncThunk(
	'flashSale/product/add',
	async ({ flashSaleId, payload }, { rejectWithValue }) => {
		try {
			const response = await apiConfig.post(`flash-sale-products/add/${flashSaleId}`, payload);
			return response.data;
		} catch (error) {
			if (!error.response) {
				throw error;
			}
			return rejectWithValue(error.response.data);
		}
	}
);

export const updateProduct = createAsyncThunk(
	'flashSale/product/update',
	async ({ flashSaleId, id, payload }, { rejectWithValue }) => {
		try {
			const response = await apiConfig.put(`flash-sale-products/update/${flashSaleId}/${id}`, payload);
			return response.data;
		} catch (error) {
			if (!error.response) {
				throw error;
			}
			return rejectWithValue(error.response.data);
		}
	}
);

export const deleteProduct = createAsyncThunk(
	'flashSale/product/delete',
	async ({ flashSaleId, id }, { rejectWithValue }) => {
		try {
			const response = await apiConfig.delete(`flash-sale-products/delete/${flashSaleId}/${id}`);
			return response.data;
		} catch (error) {
			if (!error.response) {
				throw error;
			}
			return rejectWithValue(error.response.data);
		}
	}
);

export const updateOrder = createAsyncThunk(
	'flashSale/product/patch',
	async ({ flashSaleId, payload }, { rejectWithValue }) => {
		try {
			const response = await apiConfig.patch(`flash-sale-products/patch/${flashSaleId}`, payload);
			return response.data;
		} catch (error) {
			if (!error.response) {
				throw error;
			}
			return rejectWithValue(error.response.data);
		}
	}
);

const flashSaleProductsManagementSlice = createSlice({
	name: 'flashSaleProductsManagement',
	initialState: {
		flashSale: {},
		productsByCategory: [],
    flashSaleProducts: [],
	},
	reducers: {},
	extraReducers: {
		[getFlashSaleById.fulfilled]: (state, action) => {
			const response = action.payload;
			state.flashSale = response && response.data ? response.data : null;
		},
		[getProducts.fulfilled]: (state, action) => {
			const response = action.payload;
			const data = response && response.data ? response.data : [];
			state.flashSaleProducts = data;
		}
	},
});

export const assetManagementActions = flashSaleProductsManagementSlice.actions;
export default flashSaleProductsManagementSlice.reducer;
